/* ------------------------------------*\
	VARIABLE DECLARATION
\*------------------------------------*/

home = {
	setupCursorHome: function () {
		let $cursor = $('.title-cursor');
		let $link = $('.project-hover');
		let prev_title = "";

		$link.on('mouseenter', function (event) {
			if ($(this).attr('data-title') != prev_title || prev_title === "") {
				let $c_title = $(this).attr('data-title');
				$cursor.html($c_title);
			}
			$cursor.css({
				"transform": "translate3d(" + (event.clientX + 20) + "px, " + (event.clientY - 5) + "px, 0px)"
			});
			$cursor.addClass('active');
		}).on('mousemove', function (event) {
			$cursor.css(
				{ "transform": "translate3d(" + (event.clientX + 20) + "px, " + (event.clientY - 5) + "px, 0px)" }
			)
		}).on('mouseleave', function () {
			$cursor.removeClass('active');
			prev_title = $(this).attr('data-title');
		});
	},

	setupCursorIndex: function () {
		// Cache DOM elements
		const $projectItems = $('.p-front-page-projects-index .p-front-page-projects-single');
		const headerHeight = $('header').outerHeight();

		// Throttle function to limit mousemove events
		const throttle = (func, limit) => {
			let inThrottle;
			return function (...args) {
				if (!inThrottle) {
					func.apply(this, args);
					inThrottle = true;
					setTimeout(() => inThrottle = false, limit);
				}
			};
		};

		// Handle mouse interactions
		$projectItems.each(function () {
			const $item = $(this);
			const $image = $('.p-front-page-projects-single-image');

			// Optimized mousemove handler
			const handleMouseMove = throttle((event) => {
				const $img = $(this).find('img');
				const imageWidth = $img.outerWidth() * 0.5;
				const imageHeight = $img.outerHeight() * 0.5;
				const windowWidth = $(window).width() * 0.98;
				const windowHeight = $(window).height();

				// Calculate base position
				let x = event.clientX - imageWidth;
				let y = event.clientY - imageHeight;

				// Adjust X position to keep image within viewport
				if (event.clientX > windowWidth - imageWidth) {
					x = windowWidth - $img.outerWidth();
				} else if (event.clientX < imageWidth) {
					x = 0;
				}

				// Adjust Y position to keep image within viewport, below the header
				if (event.clientY > windowHeight - imageHeight) {
					y = windowHeight - $img.outerHeight();
				} else if (y < headerHeight) {
					y = headerHeight;
				}

				const transform = `translate3d(${x}px, ${y}px, 0)`;
				$image.css('transform', transform);
			}, 16); // ~60fps

			$item
				.on('mouseenter', (ev) => {
					$(this).find('.p-front-page-projects-single-image').addClass('active');
					handleMouseMove(ev);
				})
				.on('mousemove', handleMouseMove)
				.on('mouseleave', () => {
					$(this).find('.p-front-page-projects-single-image').removeClass('active');
					// $image.css('transform', '');
				});
		});
	},

	setupIndexPageToggle: function () {
		// index toggle
		let $i_toggle = $('.header-in-index-toggle');
		let $projects_container = $('.p-front-page-projects');
		$i_toggle.on('click', function () {
			if (utils.isMobile() || utils.isSmallScreen()) {
				$("html, body").animate({ scrollTop: "0" }, Math.max(0.25, $(window).scrollTop() / 5));
			} else {
				$projects_container.toggleClass('index');
				$(window).scrollTop(0);
				$(this).toggleClass('index');
			}
		});

	},

	setupPage: function () {
		if (utils.enableDebug) {
			console.log(
				'<!-- ----------------------------------------------------- -->\n' +
				'<!-- HOME -->\n' +
				'<!-- ----------------------------------------------------- -->');
		}

		home.setupIndexPageToggle();
		if (!utils.isMobile() && !utils.isSmallScreen()) {
			home.setupCursorHome();
			home.setupCursorIndex();
		}
	}
};
